import { render, staticRenderFns } from "./commodityModal.vue?vue&type=template&id=430d4cd3&scoped=true&"
import script from "./commodityModal.vue?vue&type=script&lang=js&"
export * from "./commodityModal.vue?vue&type=script&lang=js&"
import style0 from "./commodityModal.vue?vue&type=style&index=0&id=430d4cd3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430d4cd3",
  null
  
)

export default component.exports